module.exports = "/assets/ca4b8aed547ba5a1fc07562cf0a552e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/9M.png
// module id = 1165
// module chunks = 0